<template>
    <v-container>
        <v-row justify="center">
            <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
                <v-col align="center">
                    <v-chip large color="cardColour secondary--text" class="px-6"> <span class="steps"> 1 </span> </v-chip>
                    <br/> <br/>
                    <v-divider class="line-divider"></v-divider> <v-divider class="line-divider"></v-divider>
                    <br/> <br/>
                    <v-row justify="center">
                        <h2 class="primary--text"> You have waste </h2>
                    </v-row>
                    <v-row justify="center">
                        <v-img 
                        src="@/assets/You have waste.svg" 
                        alt="Imange1"  
                        max-height="200"
                        max-width="200"
                        style="margin-top: -1.5cm;"
                        contain
                        />
                    </v-row>
                    <v-row justify="center" class="pt-6">
                        <v-col align="center">
                            <p class="white--text pl-4"> Get a quote with no hidden fees or charges for your waste </p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col align="center">
                    <v-chip large color="cardColour secondary--text" class="px-6"> <span class="steps"> 2 </span> </v-chip>
                    <br/> <br/>
                    <v-divider class="line-divider"></v-divider><v-divider class="line-divider"></v-divider>
                    <br/> <br/>
                    <v-row justify="center">
                        <h2 class="primary--text"> Sign up it's free </h2>
                    </v-row>
                    <v-row justify="center">
                        <v-img 
                        src="@/assets/Sign up.svg" 
                        alt="Imange1"  
                        max-height="170"
                        max-width="170"
                        class="pt-10"
                        contain
                        />
                    </v-row>
                    <v-row justify="center">
                        <v-col align="center">
                            <p class="white--text par"> Use our website to save time </p>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
                <v-col align="center">
                    <v-chip large color="cardColour secondary--text" class="px-6"> <span class="steps"> 3 </span> </v-chip>
                    <br/> <br/>
                    <v-divider class="line-divider"></v-divider><v-divider class="line-divider"></v-divider>
                    <br/> <br/>
                    <v-row justify="center">
                        <h2 class="primary--text"> Book our service </h2>
                    </v-row>
                    <v-row justify="center">
                        <v-img 
                        src="@/assets/Landing_book.svg" 
                        alt="Imange1"  
                        max-height="170"
                        max-width="170"
                        class="pt-10"
                        contain
                        />
                    </v-row>
                    <v-row justify="center">
                        <v-col align="center">
                            <p class="white--text"> Book your waste service and pay thereafter via secure card or EFT </p>
                        </v-col>
                    </v-row>
                </v-col> 
                <v-col align="center">
                    <v-chip large color="cardColour secondary--text" class="px-6"> <span class="steps"> 4 </span> </v-chip>
                    <br/> <br/>
                    <v-divider class="line-divider"></v-divider><v-divider class="line-divider"></v-divider>
                    <br/> <br/>
                    <v-row justify="center">
                        <h2 class="primary--text"> Waste is removed </h2>
                    </v-row>
                    <v-row justify="center">
                        <v-img 
                        src="@/assets/Waste removed.png" 
                        alt="Imange1"  
                        max-height="170"
                        max-width="170"
                        class="pt-10 pb-4"
                        contain
                        />
                    </v-row>
                    <v-row justify="center">
                        <v-col align="center">
                            <p class="white--text pr-4"> We deliver or collect your waste in as little as 24 hours from booking & payment </p>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-row>
    </v-container>
    
</template>
<script>
export default {
    name: 'HowItWorks',
    data () {
        return{

        }
        
    },
}
</script>
<style scoped>

</style>